<div class="student-chiclet-bar">
  @for (student of students(); track student.id) {
    <lt-student-chiclet [student]="student" (selected)="onStudentSelected(student.id)" />
  }
</div>
